import { Navigate, Route, Routes } from "react-router-dom";
import Header from "../components/headerLayout/headerLayout";
import MenuAside from "../components/menu-aside/menu-aside";
import Arquivos from "../pages/Arquivos/Arquivos";
import Dowloads from "../pages/dowloads/dowloads";
import Temas from "../pages/layout-temas/temas";
import Manual from "../pages/manual/manual";
import Perguntas from "../pages/perguntas/perguntas";
import Privacidade from "../pages/politica-de-privacidade/privacidade";
import Relatorio from "../pages/relatorio/relatorio";
import MandalaSetor from "../pages/mandala-setor/mandala-setor";
import RelatorioConjunto from "../pages/relatorioConjunto/relatorioConjunto";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


function AppRoutes(){
    const user = JSON.parse(localStorage.getItem("@user")) || {};

    return(
        <>
            <ToastContainer
                position="bottom-right"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <MenuAside />
            <Header/>
            
            <Routes>      
                <Route exact path="/" element={<Temas/>}/>
                <Route exact path="/questionario/:id" element={<Perguntas/>}/>
                <Route exact path="/relatorio" element={<Relatorio/>}/> 
                {user?.admin === 1 ? (
                    <Route exact path="/mandala-setor" element={<MandalaSetor/>}/> 
                ) : (
                    <Route exact path="/mandala-setor" element={<Navigate to="/" replace/>}/> 
                )}
                <Route exact path="/manual" element={<Manual/>}/> 
                <Route exact path="/downloads" element={<Dowloads />}/> 
                <Route exact path="/politica-de-privacidade" element={<Privacidade/>}/>
                <Route exact path="/cadastro3" element={<Navigate to='/' replace/>}/>
                <Route exact path="/relatorio-conjunto" element={<RelatorioConjunto/>}/>
                <Route exact path="/arquivos/:id/:name" element={<Arquivos/>}/> 
 
            </Routes> 
        </>
    )
}

export default AppRoutes;